:host {
  display: grid;
  place-items: center;
  height: 100%;
}

:host(.a) {
  padding: 1rem;
}

@media (min-width: 1024px) {
  :host(.a) {
    padding: 2rem;
  }
}

@media (min-width: 1350px) {
  :host(.a) {
    padding: 3rem;
  }
}

:host(.a) ::slotted(.quote) {
  font-size: 30px;
  font-family: var(--cwc-font-serif, 'Lora');
  line-height: 1.466;
  position: relative;
  text-indent: var(--cwc-quote-text-indent);
  margin-top: auto;
  margin-bottom: 0;
  width: 100%;
}


:host(.a) ::slotted(.quote):before,
:host(.b) .quote-container .quote:before {
  content: "\201C";
}

:host(.a) ::slotted(.quote):before {
  content: "\201C";
  color: var(--cwc-quote-color);
  font-family: inherit;
  font-size: var(--cwc-quote-size);
  line-height: 1;
  position: var(--cwc-quote-position);
  text-indent: 0;
  top: var(--cwc-quote-top);
  left: 0px;
  margin-right: 5px;
}

:host(.a) ::slotted(.quote):after,
:host(.b) .quote-container .quote:after {
  content: "\201D";
}

:host(.a) .quote-container {
  display: none;
}

:host(.a) ::slotted(.attribution) {
  font-family: var(--cwc-font-sans-serif-regular, 'Eina01-Regular');
  font-size: 18px;
  line-height: 1;
  margin-top: 1rem;
  margin-bottom: auto;
  width: 100%;
}

:host(.b) {
  padding: 0 !important;
  grid-template-rows: 1fr auto;
}

:host(.b) ::slotted(.quote) {
  display: none;
}


:host(.b) .quote-container {
  display: grid;
  place-items: center;
  font-size: 30px;
  font-family: var(--cwc-font-serif, 'Lora');
  line-height: 1.466;
  position: relative;
  margin: 0;
  height: inherit;
  background-color: var(--cwc-color-secondary-800, #5A6973);
}

:host(.b) .quote-container .quote {
  margin: 0;
}

:host(.b) .quote-container .quote,
:host(.b) ::slotted(.attribution) {
  padding: 1rem;
}

:host(.b) ::slotted(.attribution) {
  padding: 1rem;
  width: 100%;
}

@media (min-width: 1024px) {
  :host(.b) .quote-container .quote,
  :host(.b) ::slotted(.attribution) {
    padding: 2rem;
  }
}

@media (min-width: 1350px) {
  :host(.b) .quote-container .quote,
  :host(.b) ::slotted(.attribution) {
    padding: 3rem;
  }
}

:host(.b) ::slotted(.attribution) {
  background-color: var(--cwc-color-secondary, #333F48);
  font-family: var(--cwc-font-sans-serif-regular, 'Eina01-Regular');
  margin: 0;
}

.text-sunrise {
  color: var(--cwc-color-primary, #FFAD00);
}
.text-charcoal {
  color: var(--cwc-color-secondary-900, #242424);
}
.text-charcoal80 {
  color: var(--cwc-color-secondary-800, #5A6973);
}
.text-charcoal60 {
  color: var(--cwc-color-secondary-600, #7B858B);
}
.text-charcoal40 {
  color: var(--cwc-color-secondary-400, #A3AAAD);
}
.text-charcoal20 {
  color: var(--cwc-color-secondary-200, #CFD3D3);
}
.text-charcoal05 {
  color: var(--cwc-color-secondary-050, #F2F2F2);
}
.text-river {
  color: var(--cwc-color-accent-b, #008EAA);
}
.text-boise-blue {
  color: var(--cwc-color-accent-c, #0057B8);
}
.text-frost {
  color: var(--cwc-color-accent-d, #C1C6C8);
}
.text-treetop {
  color: var(--cwc-color-accent-a, #009A44);
}
.text-red {
  color: var(--cwc-color-red, #ff3232);
}
.text-white {
  color: var(--cwc-color-white, #fff);
}
